import type * as THREE from 'three';

export interface CloudQualitySettings {
  raySteps: number;
  lightSteps: number;
  resolutionScale: number;
  temporalBlend: number;
}

export const QUALITY_PRESETS: Record<string, CloudQualitySettings> = {
  low:    { raySteps: 40,  lightSteps: 3, resolutionScale: 0.25, temporalBlend: 0.90 },
  medium: { raySteps: 60,  lightSteps: 4, resolutionScale: 0.25, temporalBlend: 0.95 },
  high:   { raySteps: 90,  lightSteps: 6, resolutionScale: 0.5,  temporalBlend: 0.95 },
};

export interface CloudsProps {
  radius: number;
  sunPosition: THREE.Vector3;
  coverage?: number;
  density?: number;
}
